import type { CatalogUiSort } from "../api/types";

export const CATALOG_DEFAULT_SORT: CatalogUiSort = "collector_asc";

export const CATALOG_SORT_OPTIONS: Array<{
  value: CatalogUiSort;
  label: string;
  description: string;
}> = [
  {
    value: "collector_asc",
    label: "Номер ↑",
    description: "Номер коллекционера по возрастанию",
  },
  {
    value: "collector_desc",
    label: "Номер ↓",
    description: "Номер коллекционера по убыванию",
  },
  { value: "name_asc", label: "А–Я", description: "Название А–Я" },
  { value: "name_desc", label: "Я–А", description: "Название Я–А" },
  { value: "rare_first", label: "Редкие", description: "Редкие сначала" },
];

/** Years supplied by the catalog API's actual persisted catalog, newest first. */
export function catalogYearOptions(years: readonly number[]): number[] {
  return [...new Set(years)]
    .filter((year) => Number.isInteger(year) && year >= 1900 && year <= 9999)
    .sort((a, b) => b - a);
}

export type CatalogFilters = {
  query: string;
  year: string;
  sort: CatalogUiSort;
  rareOnly: boolean;
};

export function defaultCatalogFilters(): CatalogFilters {
  return {
    query: "",
    year: "",
    sort: CATALOG_DEFAULT_SORT,
    rareOnly: false,
  };
}

export function catalogFingerprint(filters: CatalogFilters): string {
  return `${filters.query.trim()}|${filters.year}|${filters.sort}|${filters.rareOnly ? "1" : "0"}`;
}

export function filtersToSearchParams(filters: CatalogFilters): URLSearchParams {
  const params = new URLSearchParams();
  const q = filters.query.trim();
  if (q) {
    params.set("q", q);
  }
  if (/^\d{4}$/.test(filters.year)) {
    params.set("year", filters.year);
  }
  if (filters.sort !== CATALOG_DEFAULT_SORT) {
    params.set("sort", filters.sort);
  }
  if (filters.rareOnly) {
    params.set("rare", "1");
  }
  return params;
}

export function filtersFromSearchParams(params: URLSearchParams): CatalogFilters | null {
  const hasAny =
    params.has("q") || params.has("year") || params.has("sort") || params.has("rare");
  if (!hasAny) {
    return null;
  }

  const yearRaw = params.get("year") ?? "";
  const year = /^\d{4}$/.test(yearRaw) ? yearRaw : "";
  const sortRaw = params.get("sort");
  const sort = CATALOG_SORT_OPTIONS.some((option) => option.value === sortRaw)
    ? (sortRaw as CatalogUiSort)
    : CATALOG_DEFAULT_SORT;
  const rareRaw = (params.get("rare") ?? "").toLowerCase();

  return {
    query: params.get("q") ?? "",
    year,
    sort,
    rareOnly: rareRaw === "1" || rareRaw === "true",
  };
}

export function yearFromFilter(year: string): number | undefined {
  if (!/^\d{4}$/.test(year)) {
    return undefined;
  }
  return Number(year);
}
